import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import React from 'react';

import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ErrorPage = ({ err }) => {
    const { translate: T } = useLocale();

    const status = err?.status || 500;
    let message = '';

    switch (status) {
        case 404:
            message = 'Page not found.';
            break;

        default:
            message = 'Sorry, something went wrong.';
    }

    return (
        <>
            <Helmet>
                <meta
                    content='noindex, nofollow'
                    name='robots'/>

                <title>{T(message)}</title>
            </Helmet>

            <main
                className='layout-container'
                id='main-content'>
                <div className='h-screen flex'>
                    <div className='w-full md:w-6/12 flex flex-col gap-10 md:gap-20 m-auto'>
                        <h1 className='type-style-2'>{T(`Error ${status}`)}</h1>

                        {message && (
                            <p>{T(message)}</p>
                        )}

                        <p>
                            <a
                                className='underline'
                                href='/'>{T('Press here to return to the homepage')}</a>
                        </p>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    err: PropTypes.object
};

ErrorPage.propTypes = propTypes;

export default ErrorPage;
